<template>
  <div class="app-list pep-sources">
    <div class="app-list__header">
      <span class="app-list__cell app-list__cell--left">
        {{ 'verification-details-pep-info.sources.dates' | globalize }}
      </span>
      <span class="app-list__cell app-list__cell--center">
        {{ 'verification-details-pep-info.sources.amltypes' | globalize }}
      </span>
      <span class="app-list__cell app-list__cell--right">
        {{ 'verification-details-pep-info.sources.details' | globalize }}
      </span>
    </div>
    <div
      v-for="item in output"
      :key="item.id"
      class="app-list__li">
      <span class="app-list__cell app-list__cell--left">
        {{ item.notes.listingStartedUtc | formatDateDMY }}
        - {{ item.notes.listingEndedUtc | formatDateDMY }}
      </span>
      <span class="app-list__cell app-list__cell--center">
        <span
          class="verifications-components-pep-aka"
          :key="type"
          v-for="type in item.notes.amlTypes">
          {{ type }}
        </span>
      </span>
      <span class="app-list__cell app-list__cell--right">
        <a
          target="_blank"
          :title="item.notes.name"
          :href="item.notes.url">{{ item.notes.name }}</a>
      </span>
    </div>
  </div>
</template>

<script>

/*
input model
{
  sources: [string]
  source_notes: {
    [string_from_sources]: {
      aml_types: [string],
      listing_ended_utc: date,
      listing_started_utc: date,
      name,
      url
    }
  }
  fields: [{ name: string, source: string-from-sources, value: string }]
  types: [string]
}

output model
[
]
*/
import { camelCaseFromHypencase } from '@/js/helpers/case-converter'

export default {
  name: 'verification-details-pep-sources',
  components: {},
  props: {
    sources: {
      type: Array,
      required: true,
    },
    sourceNotes: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  async created () {
    this.output = []

    this.sources.forEach(source => {
      const camelized = camelCaseFromHypencase(source)
      const fields = this.fields.filter(f => f.source === source)
      const row = {
        id: source,
        notes: this.sourceNotes[camelized],
        fields,
      }

      this.output.push(row)
    })
    this.output = this.output.sort(function (a, b) {
      const ad = new Date(a.notes.listingStartedUtc)
      const bdt = new Date(b.notes.listingStartedUtc)
      return ad - bdt
    })
  },
}
</script>

<style scoped>
  @import './style.css';
</style>
